// Copyright (c) 2019 Deere & Company

export const PartGroupTwoTableColumnDefinitions = [
    {
        field: 'productSeriesName',
        headerName: 'Product Series',
        sortable: true,
        filter: true,
        width: 400,
    },
    {
        field: 'functionCodeName',
        headerName: 'Function Code',
        sortable: true,
        filter: true,
        width: 400,
    },
];
